<template>
  <v-app-bar v-bind="attrs" app  clipped-left data-cy="toolbar" color="primary">
    <slot name="toolbar-avatar">
      <v-avatar style="cursor: pointer" @click="gotoHome" size="85" class="ml-3" tile data-cy="toolbar-avatar">
        <v-img :src="logo" width="100%" contain data-cy="toolbar-img"/>
      </v-avatar>
    </slot>

    <slot name="toolbar-title">
        <v-toolbar-title style="cursor: pointer" @click="gotoHome" color="accent" class="pl-3 pr-2" data-cy="toolbar-title">Money Plus</v-toolbar-title>
    </slot>

    <slot name="toolbar-drawer">
      <v-app-bar-nav-icon @click.stop="$store.commit('drawer')" data-cy="toolbar-icon">
      </v-app-bar-nav-icon>
    </slot>

    <slot name="toolbar-before-space"></slot>

    <v-spacer></v-spacer>

    <slot name="toolbar-after-spacer"></slot>

    <slot name="toolbar-timer">
      <Timer></Timer>
    </slot>

    <slot name="toolbar-options">
      <v-menu offset-y data-cy="toolbar-menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            tile
            class="text-subtitle-2"
            v-bind="attrs"
            v-on="on"
            data-cy="toolbar-menu-button">
            {{ userIdentificador }}
            <v-icon class="pl-2" data-cy="toolbar-menu-icon">mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-list dense data-cy="toolbar-list">
          <!-- <v-list-item link data-cy="toolbar-list-item-profile">
            <v-list-item-title data-cy="toolbar-list-item-profile-title">
              <v-icon small class="pr-2" color="secondary" data-cy="toolbar-list-item-profile-icon">mdi-account</v-icon>
              Perfil
            </v-list-item-title>
          </v-list-item> -->
          <slot name="toolbar-user-options"></slot>
          <v-list-item link @click="logout" data-cy="toolbar-list-item-logout">
            <v-list-item-title data-cy="toolbar-list-item-logout-title">
              <v-icon small class="pr-2" color="error" data-cy="toolbar-list-item-logout-icon">mdi-exit-to-app</v-icon>
              Sair
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </slot>
  </v-app-bar>
</template>

<script>
import logo from 'shared/images/svg/logo-black.svg'
export default {
  data () {
    return {
      logo,
      userIdentificador: ''
    }
  },
  components: {
    Timer: () => import('./OnboardingTimer.vue'),
  },
  computed: {
    attrs () {
      return { ...this.$theme.options.toolbar, ...this.$attrs }
    },
  },
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    },
    logout () {
      const th = this
      const user = this.$store.getters.user
      th.$api.Autenticacao.Logout(user.documento, user.refreshToken).then(function (data) {
        if (th.$api.UI.PostLoadData(data)) {
          th.$store.dispatch('logout')
        }
      })
        .catch((err) => console.log(err))
    }
  },
  mounted () {
    const th = this
    this.userIdentificador = th.$store.getters.user.identificador
  }
}
</script>
